import { identityApi } from '@commerce-identity-webcomponents/sdk';
import {
  useTranslation,
  useNextgenRouter,
  Modal,
  useBreakpoint,
  Button,
  ButtonWidth,
  ButtonStyles,
  ButtonAlignment,
} from '@nextgen-web-framework/all';
import { ConfigService, ConsoleLogger } from '@nextgen-web-framework/core';
import { LogoutModalOptions } from './types/propTypes';
import styles from './LogoutModal.module.scss';

const LogoutModal = (props: LogoutModalOptions) => {
  const t = useTranslation();
  const { replace } = useNextgenRouter();
  const viewPortType = useBreakpoint();
  const { NEXT_PUBLIC_GLU_BASE_URL } = ConfigService.getConfigs();
  const { idTokenHint, postLogoutRedirectUri, sessionState, onClose } = props;
  const containerWidth = ['xs', 'sm'].indexOf(viewPortType) !== -1 ? '21.4375rem' : '36rem';
  const isMobileOrTablet = ['xs', 'sm', 'md'].indexOf(viewPortType) === -1;
  const buttonWidthBasedOnViewport = isMobileOrTablet ? ButtonWidth.FIT_CONTENT : ButtonWidth.FULL_WIDTH;
  const buttonAlignnmentBasedOnViewport = isMobileOrTablet ? ButtonAlignment.HORIZONTAL : ButtonAlignment.VERTICAL;

  const clickHandler = async (event: React.KeyboardEvent<Element> | React.MouseEvent<Element, MouseEvent>) => {
    event.preventDefault();
    event.stopPropagation();
    if (typeof window !== 'undefined') {
      try {
        const logoutRes = await identityApi.getLogoutUrl({
          gluuBaseUrl: NEXT_PUBLIC_GLU_BASE_URL as string,
          postLogoutRedirectUri,
          sessionState,
          idTokenHint,
        });
        replace?.(logoutRes);
      } catch (error) {
        ConsoleLogger.error(error);
      }
    }
  };
  const getPrimaryButton = (
    <Button
      data-testid="logout-primary-button-test-id"
      title={t('identity.Logout.primaryButtonLabel')}
      buttonWidth={buttonWidthBasedOnViewport}
      onClick={clickHandler}
    />
  );
  const getSecondaryButton = (
    <Button
      data-testid="close-button-testid"
      title={t('identity.Logout.secondaryButtonLabel')}
      buttonWidth={buttonWidthBasedOnViewport}
      onClick={onClose ?? undefined}
      buttonStyle={ButtonStyles.OUTLINE}
    />
  );
  return (
    <div data-testid="LogoutModal-test-id" className={styles['identity-logout-modal-container']}>
      <Modal
        useReactPortal={true}
        portalContainerId="react-portal-modal"
        headline={t('identity.Logout.text')}
        primaryButton={getPrimaryButton}
        secondaryButton={getSecondaryButton}
        primaryButtonLabel={t('identity.Logout.primaryButtonLabel')}
        onClose={onClose}
        closeIcon={true}
        containerWidth={containerWidth}
        buttonAlignment={buttonAlignnmentBasedOnViewport}
      >
        <></>
      </Modal>
    </div>
  );
};

export default LogoutModal;
